import React from "react";
import { Link } from "react-router-dom";

import './doctorCard.css'

export default function DoctorCard({doctor}){
    return(
        <Link to={`/doctors/${doctor._id}`} className="doctor-card-link">
            <div className="doctor-card">
                <img src={doctor.image} className="doctor-card-image"/>
                <div className="doctor-details">
                    <h3 className="doctor-name">{doctor.name}</h3>
                    <p className="doctor-specialization">{doctor.specialization}</p>
                </div>
            </div>
        </Link>
    )
}
